import React, { useState } from "react";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { FaPlus, FaMinus } from "react-icons/fa";
import AddonOptionRow from "./AddonOptionRow";

const AddonField = ({
  index,
  meta,
  onChange,
  onRemoveField,
  onAddOption,
  onRemoveOption,
  onOptionChange,
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, optionIndex) => {
    setDraggedIndex(optionIndex);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const items = Array.from(meta.options || []);
    const [draggedItem] = items.splice(draggedIndex, 1);
    items.splice(dropIndex, 0, draggedItem);
    
    onChange(index, "options", items);
    setDraggedIndex(null);
  };
  return (
    <div key={index} className="p-3 mb-3">
      <div className="d-flex justify-content-between">
        <Label className="fw-bold">Field {index}</Label>
        <Button color="danger" size="sm" onClick={() => onRemoveField(index)}>
          <FaMinus /> Remove Field
        </Button>
      </div>

      <div className="d-flex align-items-center gap-2">
        <FormGroup className="w-50">
          <Label>Field Title</Label>
          <Input
            type="text"
            value={meta.title}
            onChange={(e) => onChange(index, "title", e.target.value)}
            placeholder="Field Title"
          />
        </FormGroup>
        <FormGroup check className="ms-3 mt-4">
          <Label check>
            <Input
              type="checkbox"
              checked={meta.is_required}
              onChange={(e) => onChange(index, "is_required", e.target.checked)}
            />
            Required
          </Label>
        </FormGroup>
        <FormGroup check className="ms-3 mt-4">
          <Label check>
            <Input
              type="checkbox"
              checked={meta.is_multiple}
              onChange={(e) => onChange(index, "is_multiple", e.target.checked)}
            />
            Multiple Select
          </Label>
        </FormGroup>
      </div>

      <Label>Options</Label>
      <div>
        {(meta.options || []).map((option, optionIndex) => (
          <AddonOptionRow
            key={option.id || optionIndex}
            option={option}
            index={optionIndex}
            onChange={(idx, key, value) => onOptionChange(index, idx, key, value)}
            onRemove={(idx) => onRemoveOption(index, idx)}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            isDragging={draggedIndex === optionIndex}
          />
        ))}
      </div>

      <Button color="primary" size="sm" onClick={() => onAddOption(index)}>
        <FaPlus /> Add Option
      </Button>
    </div>
  );
};

export default AddonField;
